import { FC } from 'react';
import { Brain, Target, Shield } from 'lucide-react';

const features = [
  {
    icon: Brain,
    title: "Aprendizaje Interactivo",
    description: "Lecciones dinámicas y juegos educativos que mantienen el interés y motivación de los niños"
  },
  {
    icon: Target,
    title: "Seguimiento del Progreso",
    description: "Visualización clara del avance, logros y actividades de aprendizaje para que padres y tutores acompañen el desarrollo de sus hijos"
  },
  {
    icon: Shield,
    title: "Entorno Seguro",
    description: "Plataforma diseñada específicamente para niños con contenido apropiado y supervisión"
  }
];

export const Features: FC = () => {
  return (
    <section className="py-12 md:py-24 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-2xl md:text-4xl font-bold mb-4 text-primary">
            Una plataforma completa de educación financiera
          </h2>
          <p className="text-base md:text-xl text-gray-600 max-w-3xl mx-auto px-4">
            Diseñada específicamente para niños de 8 a 12 años, 
            combinando diversión con aprendizaje efectivo
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 md:gap-8">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="p-6 rounded-xl bg-white shadow-lg hover:shadow-xl transition-shadow border border-primary/10"
            >
              <div className="h-12 w-12 rounded-lg bg-primary/10 flex items-center justify-center mb-4">
                <feature.icon className="h-6 w-6 text-primary" />
              </div>
              <h3 className="text-lg md:text-xl font-bold mb-2 text-primary">{feature.title}</h3>
              <p className="text-sm md:text-base text-gray-600">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};